import React from 'react';
import { Mail, Phone, Hash } from 'lucide-react';
import './style.css';

/**
 * CRMContactRow Molecule
 * Renders a compact row optimized for listing CRM contacts with perfect column alignment.
 */
function CRMContactRow({
    person,
    renderActions,
}) {
    const name = person.name || 'Sin Nombre';
    const email = person.email;
    const phone = person.phone;
    const identification = person.identification;
    const active = person.active;
    const documentType = person.identificationsId === 6 ? 'NIT' : person.identificationsId === 3 ? 'CC' : 'Doc';

    const initial = (name || '?').charAt(0).toUpperCase();

    // Determine type tags
    const tags = [];
    if (person.client) tags.push({ label: 'Cliente', className: 'tag-client' });
    if (person.provider) tags.push({ label: 'Proveedor', className: 'tag-provider' });
    if (person.other) tags.push({ label: 'Otro', className: 'tag-other' });

    return (
        <div className={`crm-contact-row ${!active ? 'crm-contact-row--inactive' : ''}`}>
            {/* Identity Column */}
            <div className="crm-row-col crm-row-col--identity">
                <div className={`crm-row-avatar ${person.provider ? 'crm-avatar-provider' : 'crm-avatar-client'}`}>
                    <span className="crm-row-avatar-initial">{initial}</span>
                </div>
                <div className="crm-row-identity-text">
                    <span className="crm-row-name" title={name}>{name}</span>
                    <div className="crm-row-tags">
                        {tags.map((tag, i) => (
                            <span key={i} className={`crm-tag ${tag.className}`}>
                                {tag.label}
                            </span>
                        ))}
                    </div>
                </div>
            </div>

            {/* Document Column */}
            <div className="crm-row-col crm-row-col--doc">
                <Hash size={14} className="crm-row-icon" />
                <span className="crm-row-text">{identification ? `${documentType}: ${identification}` : 'Sin Documento'}</span>
            </div>

            {/* Contact Information Column */}
            <div className="crm-row-col crm-row-col--info">
                {email && (
                    <div className="crm-row-subcol">
                        <Mail size={14} className="crm-row-icon" />
                        <a href={`mailto:${email}`} className="crm-row-link" title={email}>{email}</a>
                    </div>
                )}
                {phone && (
                    <div className="crm-row-subcol">
                        <Phone size={14} className="crm-row-icon" />
                        <a href={`tel:${phone}`} className="crm-row-link">{phone}</a>
                    </div>
                )}
            </div>

            {/* Status Column */}
            <div className="crm-row-col crm-row-col--status">
                <span className={`crm-row-status-badge crm-row-status-badge--${active ? 'active' : 'inactive'}`}>
                    {active ? 'Activo' : 'Inactivo'}
                </span>
            </div>

            {/* Actions Column */}
            {renderActions && (
                <div className="crm-row-col crm-row-col--actions">
                    {renderActions(person)}
                </div>
            )}
        </div>
    );
}

export default CRMContactRow;
